import {
  addDays,
  addWeeks,
  endOfISOWeek,
  getISOWeek,
  getMonth,
  getYear,
  startOfISOWeek,
  subWeeks,
} from 'date-fns';
import { useLocalStore } from 'mobx-react-lite';

export const useCalendarWeekView = (date) => {
  const state = useLocalStore(() => ({
    currentViewBase: date ? new Date(date) : new Date(),
    selected: date ? new Date(date) : new Date(),
    selectDate(date) {
      state.selected = date;
    },
    resetBase() {
      state.currentViewBase = new Date();
    },
    nextWeek() {
      state.currentViewBase = addWeeks(state.currentViewBase, 1);
      state.selected = date ? new Date(date) : new Date();
    },
    prevWeek() {
      state.currentViewBase = subWeeks(state.currentViewBase, 1);
      state.selected = date ? new Date(date) : new Date();
    },
    get baseYear() {
      return getYear(state.currentViewBase);
    },
    get showYear() {
      const selectedWeek = startOfISOWeek(state.selected);
      const viewBaseWeek = startOfISOWeek(state.currentViewBase);
      const selectedYear = getYear(state.selected);
      const viewBaseYear = getYear(state.currentViewBase);
      return selectedYear !== viewBaseYear && selectedWeek !== viewBaseWeek;
    },
    get month() {
      const startMonth = getMonth(startOfISOWeek(state.currentViewBase));
      const endMonth = getMonth(endOfISOWeek(state.currentViewBase));
      if (startMonth !== endMonth) {
        return `${monthMap[startMonth]} - ${monthMap[endMonth]}`;
      }
      return monthMap[getMonth(startOfISOWeek(state.currentViewBase))];
    },
    get week() {
      return getISOWeek(state.currentViewBase);
    },
    get days() {
      const first = startOfISOWeek(state.currentViewBase);
      return [
        { title: 'Mán', date: first },
        { title: 'Þri', date: addDays(first, 1) },
        { title: 'Mið', date: addDays(first, 2) },
        { title: 'Fim', date: addDays(first, 3) },
        { title: 'Fös', date: addDays(first, 4) },
        { title: 'Lau', date: addDays(first, 5) },
        { title: 'Sun', date: addDays(first, 6) },
      ];
    },
  }));

  return state;
};

const monthMap = [
  'Janúar',
  'Febrúar',
  'Mars',
  'Apríl',
  'Maí',
  'Júní',
  'Júlí',
  'Ágúst',
  'September',
  'Október',
  'Nóvember',
  'Desember',
];
